module.exports = __webpack_public_path__ + "img/capital.e2417177.png";